if (!customElements.get('image-with-text-slider')) {
  class ImwiteSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: 1,
        navigation: {
          nextEl: '.section-image-with-text-slider__swiper--wrapper .swiper-button--next-imws',
          prevEl: '.section-image-with-text-slider__swiper--wrapper .swiper-button--prev-imws',
        },

        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 1,
            loop: false,
            navigation: {
              nextEl: '.section-image-with-text-slider__swiper--wrapper .swiper-button--next-imws',
              prevEl: '.section-image-with-text-slider__swiper--wrapper .swiper-button--prev-imws',
            }
          }
        }
      });
    }
  }

  customElements.define('image-with-text-slider', ImwiteSlider);
}
